import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2vw 0;

  h4 {
    font-family: Poppins;
    font-size: 2.431vw;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.15000000596046448px;
    text-align: center;
  }

  h5 {
    font-family: Poppins;
    font-size: 1.389vw;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.15000000596046448px;
    text-align: center;
  }
`;
